import Image from 'next/image'
interface PromotionWidgetProps {
  product: any
  promotionImages: any
}
const PromotionWidget = ({
  product,
  promotionImages,
}: PromotionWidgetProps) => {
  return (
    <>
      {product && (
        <div className="widgetshadow p-6 rounded-2 grid grid-cols-12 mt-6 items-center bg-brand-polar-white">
          <div className="flex flex-col gap-4 col-span-9">
            {product?.promotion.pdpTitle && (
              <div className="label-bold font-bold text-message-warning-text">
                {product.promotion.pdpTitle}
              </div>
            )}
            {product?.promotion.pdpDescription && (
              <div className="text-subdued">
                {product.promotion.pdpDescription}
              </div>
            )}
            {product?.promotion.pdpNote && (
              <div className="text-text-disabled">
                {product.promotion.pdpNote}
              </div>
            )}
          </div>
          {product && (
            <div className="col-span-3 justify-center relative m-1">
              {promotionImages && (
                <Image
                  alt={promotionImages.altText}
                  src={promotionImages.url}
                  width={promotionImages.width || 88}
                  height={promotionImages.height || 88}
                  layout="responsive"
                  blurDataURL={promotionImages.url}
                  placeholder="blur"
                />
              )}
            </div>
          )}
        </div>
      )}

      <style jsx>
        {`
          .widgetshadow {
            box-shadow: 0px 4px 8px rgba(179, 179, 179, 0.12);
          }
        `}
      </style>
    </>
  )
}
export default PromotionWidget
